import React, {useContext, useEffect, useState} from 'react';
import {inject, observer} from "mobx-react";
import ym from 'react-yandex-metrika';
import {dispatchCheckPhone, dispatchVerifyCode} from '../../../api/Registration/api'
import RegWrapper from './RegWrapper';
import LoadingSpinner from '../../ui/loadingSpinner';
import RegForm from './RegForm';
import RegFormRow from './RegFormRow';
import Alert from '../../ui/alert';
import NumberConfirm from './NumberConfirm';
import Button from '../../ui/btn';
import {fieldValidator, getLang} from '../../../common';
import {RegContext} from "./RegContext";
import {resSuccess, resError} from "./utils/constants";
import {logForSmsCodeEntered, logForBackStep, logForSmsCodeRepeat} from "../../../logger/loggerRegForm";

const Step2 = inject('appStore', 'kafkaStore')(observer((props) => {
	const {
		kafkaStore: {
			imprintHash
		},
		brandName,
		lang,
		langId,
		translationForReg,
		formData,
		token,
		regFormTitle
	} = props;

	const [isLoading, setIsLoading] = useState(true);
	const [wait, setWait] = useState(false);
	const [verifyCode, setVerifyCode] = useState(null);
	const [errorMessages, setErrorMessages] = useState({
		verifyCode: '',
		formError: '',
	});

	const {updateData} = useContext(RegContext)

	useEffect(() => {
		setIsLoading(false);
	}, []);

	// Обрабатываю ошибки с сервера
	const requestError = (error, type) => {
		if (error.key?.length > 0) {
			setErrorMessages({
				...errorMessages,
				[type]: error.text
			})
		} else {
			setErrorMessages({
				...errorMessages,
				[type]: error.text
			})
		}
	}

	const onChangePhone = () => {
		logForBackStep({step: 1}, imprintHash);
		updateData({
			step: 1
		});
	};

	const onRepeatSms = async () => {
		formData.token = token;
		const response = await dispatchCheckPhone(formData);

		logForSmsCodeRepeat(
			response.data.code !== 0 ? resError : resSuccess,
			response.data.code !== 0 && {code: response.data.code, message: response.data.text},
			imprintHash
			)

		if (response.data.code === 1) {
			if (response.data.text.length > 0) {
				setErrorMessages({
					verifyCode: response.data.text
				})
			} else {
				setErrorMessages({
					formError: getLang(translationForReg, brandName, lang, 'serverErr')
				})
			}

		}
		return response;
	};

	const onInputVerifyCode = (e) => {
		e.preventDefault();
		const value = e.target.value;
		if (fieldValidator(value, {
			number: true,
			maxLength: 4,
		}).isValid || value === 0) {
			setVerifyCode(value);
		}
	};

	const checkVerifyCode = async () => {
		const formData = new FormData()
		formData.append("verify_code", verifyCode)

		const response = await dispatchVerifyCode(formData)

		logForSmsCodeEntered(response.data.code !== 0 ? resError : resSuccess, imprintHash);

		if (response.data.code === 1) {
			requestError(response.data, 'verifyCode')
		} else {
			return true
		}
		return false
	};

	const onSubmitHandler = async (e) => {
		e.preventDefault();
		if (!fieldValidator(verifyCode, {minLength: 4}).isValid) {
			setErrorMessages({
				...errorMessages,
				verifyCode: getLang(translationForReg, brandName, lang, 'smsCodeErr')
			});
			return null;
		}

		setWait(true)

		const result = await checkVerifyCode(verifyCode);
		if (result === true) {
			ym('reachGoal','toStep3')
			updateData({
				step: 3
			});
		} else {
			setWait(false)
		}

	};

	if (isLoading) return <LoadingSpinner/>;

	return (
		<RegWrapper
			brandName={brandName}
			lang={lang}
			langId={langId}
			translationForReg={translationForReg}
			title={regFormTitle}
			subtitle={getLang(translationForReg, brandName, lang, 'formSubTitle')}
		>
			{wait ? <LoadingSpinner/> : null}
			<RegForm>
				<RegFormRow>
					{errorMessages.formError ?
						<Alert
							className='alert-danger'
							message={errorMessages.formError}
						/> : null
					}
				</RegFormRow>
				<RegFormRow>
					<NumberConfirm
						brandName={brandName}
						lang={lang}
						translationForReg={translationForReg}
						formData={formData}
						verifyCode={verifyCode}
						onChangePhone={onChangePhone}
						onRepeatSms={onRepeatSms}
						onInputVerifyCode={onInputVerifyCode}
						errorMessage={errorMessages.verifyCode}
					/>
				</RegFormRow>
				<RegFormRow>
					<Button id='toStep3' className='Registration' type='submit' onClick={onSubmitHandler}>
						{getLang(translationForReg, brandName, lang, 'regButtonText')}
					</Button>
				</RegFormRow>
			</RegForm>
		</RegWrapper>
	);
}));

export default Step2;
